import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';

import { SharedModule } from "@bt/shared";

import { LegalDomainComponent } from './legal-domain.component';
import { dirtyParentQueries } from '@angular/core/src/view/query';
import { DirectiveModule } from '@bt/directives/directive.module';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    DirectiveModule,
    FontAwesomeModule
  ],
  declarations: [
    LegalDomainComponent
  ],
})
export class LegalDomainModule { }


// WEBPACK FOOTER //
// ./src/app/legal-domain/legal-domain.module.ts